<div class="row">
  <app-card type="default"
    borderClass="border-default"
    style="max-height:fit-content; overflow: clip;">
    <div id="title"
      icon-title><span class="fa fa-newspaper-o"></span></div>
    <div id="heading"
      left-title>
      <h4 class="mb-0">Recent Programs</h4>
    </div>
    <div card-content-container>
      <div id="firstLoop">
        <div><a [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            (click)="goToProgramList(recentProgramsDataInitial?.[0]?.accntPrgrmPrdId)"
            *ngIf="recentProgramsDataInitial?.[0]?.effectiveDate">{{recentProgramsDataInitial?.[0]?.effectiveDate}}
            - {{recentProgramsDataInitial?.[0]?.expirationDate}}</a></div>
        <div>{{recentProgramsDataInitial?.[0]?.company}}</div>
        <ul class="ps-4">
          <ng-container *ngFor="let lineofBusiness of recentProgramsDataInitial?.[0]?.products">
            <li>{{titleCase(lineofBusiness?.shortName)}}</li>
          </ng-container>
        </ul>
      </div>
      <div id="secondLoop"
        >
        <div><a [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            (click)="goToProgramList(recentProgramsDataInitial?.[1]?.accntPrgrmPrdId)"
            *ngIf="recentProgramsDataInitial?.[1]?.effectiveDate">{{recentProgramsDataInitial?.[1]?.effectiveDate}}
            - {{recentProgramsDataInitial?.[1]?.expirationDate}}</a></div>
        <div>{{recentProgramsDataInitial?.[1]?.company}}</div>
        <ul class="ps-4">
          <ng-container *ngFor="let lineofBusiness of recentProgramsDataInitial?.[1]?.products">
            <li>{{titleCase(lineofBusiness?.shortName)}}</li>
          </ng-container>
        </ul>
      </div>
      <div id="thirdLoop"
        >
        <div><a [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            (click)="goToProgramList(recentProgramsDataInitial[2]?.accntPrgrmPrdId)"
            *ngIf="recentProgramsDataInitial?.[2]?.effectiveDate">
            {{recentProgramsDataInitial?.[2]?.effectiveDate}} - {{recentProgramsDataInitial?.[2]?.expirationDate}}</a></div>
        <div>{{recentProgramsDataInitial?.[2]?.company}}</div>
        <ul class="ps-4">
          <ng-container *ngFor="let lineofBusiness of recentProgramsDataInitial?.[2]?.products">
            <li>{{titleCase(lineofBusiness?.shortName)}}</li>
          </ng-container>
        </ul>
      </div>
      <div class="d-flex justify-content-between"
        *ngIf="recentProgramsDataInitial?.length ===  0">
        <div>No records found.</div>
      </div>
      <!-- Link to navigate to All Programs page -->
      <div id="allPrograms"
        class="d-flex justify-content-end mb-1"
        *ngIf="recentProgramsDataInitial?.length > 0">
        <div><a [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="icon-btn-right fa-chevron-right pt-1 pull-right align-items-center"
            (click)="goToAllPrograms()">All Programs</a></div>
      </div>
    </div>
  </app-card>
</div>